import { useInfiniteQuery } from "@tanstack/react-query";

import { getLectures } from "@/services/apiLectures";

export function useLectures({
    filter,
    include,
    includeFields,
    sortBy,
    perPage,
    courseid,
} = {}) {
    const {
        data: lectures,
        error,
        fetchNextPage,
        hasNextPage,
        isFetching,
        isFetchingNextPage,
        status,
        isPending,
    } = useInfiniteQuery({
        queryKey: [
            "courseLectures",
            perPage,
            filter,
            include,
            includeFields,
            sortBy,
            courseid,
        ],
        queryFn: ({ pageParam }) =>
            getLectures({
                filter,
                include,
                sortBy,
                pageParam,
                perPage,
                courseid,
                includeFields,
            }),
        initialPageParam: 1,
        getNextPageParam: (lastPage, allPages) => {
            return lastPage.data.length ? allPages.length + 1 : undefined;
        },
    });

    return {
        isPending,
        lectures,
        error,
        fetchNextPage,
        hasNextPage,
        isFetching,
        isFetchingNextPage,
        status,
    };
}
